import React, { useState, useContext, useEffect } from 'react';
import Parse from 'parse';
import swal from 'sweetalert';
import { AuthContext } from '../../auth';
import Counsellorsidebar from './sidebar/sidebar'
import { Redirect } from 'react-router-dom';



const Counsellorprofile = () => {

    const [name, setName] = useState("");
    const [degree, setDegree] = useState("");
    const [experience, setExperience] = useState("");
    const [bio, setBio] = useState("");
    const [logedinuser, setLogedinuser] = useContext(AuthContext);
    const [submitted, setSubmitted] = useState('');

    // useEffect(() => {
    //     const User = Parse.Object.extend("User");
    //     const query = new Parse.Query(User);

    //     query.get(logedinuser).then((counsellor) => {
    //         setDegree(counsellor.get("degree"));
    //         setExperience(counsellor.get("experience"));
    //         setName(counsellor.get("name"));
    //         setBio(counsellor.get("bio"));
    //     })

    // }, [])


    const handleSubmit = (e) => {
        e.preventDefault();
        const User = Parse.Object.extend('User');
        const query = new Parse.Query(User);

        query.get(logedinuser).then((user) => {
            user.set("name", name);
            user.set("degree", degree);
            user.set("experience", experience);
            user.set("bio", bio);
            user.save().then((data)=>{
                swal("Addedd!", "updated your profile", "success");
            setSubmitted(true);
                
            }).catch((error)=>{
                console.log(error);
                swal("Oops!", "Seems like we couldn't update your profile...Please try again in sometime", "error");
            })
            
        }).catch((err) => {
            swal("Oops!", "Seems like we couldn't update your profile...Please try again in sometime", "error");
        })

    }
    return (
        <div>
            {(logedinuser == null) && (
                <Redirect to="/counsellor/login" />
            )}
            {submitted?<Redirect to="/counsellor"></Redirect>:null}
            <Counsellorsidebar head="Counsellor Profile" />

            <div className="container " style={{marginTop:"50px"}}>
                <h1 className="head1">Update your profile</h1>
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={name}
                                onChange={e => setName(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="name" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={degree}
                                onChange={e => setDegree(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="degree" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={experience}
                                onChange={e => setExperience(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="experience" />
                        </div>
                        <div className="form-group col-lg-12  ">
                            <input type="text"
                                className="form-control"
                                id="exampleInputEmail1"
                                value={bio}
                                onChange={e => setBio(e.target.value)}
                                aria-describedby="emailHelp"
                                placeholder="bio" />
                        </div>

                    </div>
                    <div className="btndiv">
                        <button type="submit" class="authbtn btn-primary center-block mt-4">Submit</button>
                    </div>
                </form>
            </div>
        </div>
    );
};



export default Counsellorprofile;


